import SuspenseLoader from 'src/components/SuspenseLoader';
import { Suspense, lazy } from 'react';
import { Navigate, RouteObject } from 'react-router';
import BaseLayout from 'src/layouts/BaseLayout';
const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Login = Loader(lazy(() => import('src/content/auth/login')));

const authRoutes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: 'login',
        element: <Login />
      },
      {
        path: '*',
        element: <Navigate to="/login" />
      },
      {
        path: '/',
        element: <Navigate to="/login" />
      }
    ]
  }
];

export default authRoutes;
